import { differenceInDays } from 'date-fns';
import { Typography } from '@material-ui/core';
import React from 'react';

export const DaysDiffInfoText = ({
  date1,
  date2,
  maxDiff,
  beforeOrAfter,
}: {
  date1: Date;
  date2: Date;
  maxDiff?: number;
  beforeOrAfter: string;
}) => {
  const daysDiff = differenceInDays(new Date(date1), new Date(date2));

  return (
    <Typography variant="caption" style={{ display: 'block' }}>
      {maxDiff && daysDiff > maxDiff ? '90+' : daysDiff === 0 ? '' : Math.abs(daysDiff)}{' '}
      {daysDiff > 1
        ? `days before ${beforeOrAfter}`
        : daysDiff === 1
        ? `day before ${beforeOrAfter}`
        : daysDiff === -1
        ? `day after ${beforeOrAfter}`
        : daysDiff < -1
        ? `days after ${beforeOrAfter}`
        : ''}
    </Typography>
  );
};
